
import template from './chart-view.html';

/**
 * Charts List VM
 */
class ChartViewPageViewModel
{
	constructor(page) {
		this.page = page;
		this.element = page.element;
		this.assets;
		this.tables;
		this.axis_obj = {axis_id: '', name_gap: 50,	idx: 1, show: true, type: '', name: '', name_location: 'middle', position: '', field: '', selected_axis_options: []};

		this.chart_options = ko.observableArray('');
		this.series_count = ko.observable('');
		this.dataset_count = ko.observable('');

		//chart id's
		this.chart_id = ko.observable('');
		this.data_source_id = ko.observable();
		this.legend_id = ko.observable(''); 
		this.tooltip_id = ko.observable('');
		this.x_axis_id = ko.observable('');
		this.y_axis_id = ko.observable('');

		//Chart params
		this.def_grid = ko.observable(false);
		this.axes = ko.observableArray([]);
		this.def_grid.subscribe(option => {
			if (option && this.axes().length == 0)
				this.build_axis (this.axis_obj);
			}
		);

		this.available_x_axes = ko.observableArray([]);
		this.available_y_axes = ko.observableArray([]);
		this.available_axis_options = ko.observableArray(['Currency','Rotate Label', 'Split Label','Name Location - start', 'Name Location - end', 'Name Location - center']);
		this.selected_axis_options = ko.observableArray([]);


		this.data_source_type = ko.observable();
		this.chart_name = ko.observable('');
		this.title = ko.observable({
			text: ko.observable(''),
			subtext: ko.observable(''),
			title_id: ko.observable(''),
			layout_info: ko.observable()
		});
		this.category_axis = ko.observable('');
		this.x_axis_name = ko.observable('');
		this.y_axis_name = ko.observable('');
		this.source_schema = ko.observable();
		this.source_table = ko.observable();
		this.data_source_report = ko.observable('');
		this.available_reports = ko.observableArray([]);
		this.report_definition_id = ko.observable();
		this.version = ko.observable();
		this.report_table = ko.observable();
		this.raw_data = ko.observableArray();
		this.chart_size = ko.observable('large');
		this.chart_has_data = ko.observable(false);
		this.chart_options_loading = ko.observable(true);
		this.chart_options_not_loaded = ko.observable(false);
		this.loading = ko.observable(false);
		this.series = ko.observableArray([]);
		
		//Load Schemas and Tables
		this.available_schemas = ko.observableArray([]);
		this.available_columns = ko.observableArray([]);
		this.available_tables = ko.observableArray([]);
		this.available_types = ko.observableArray(["line", "bar", "pie"]);
		this.raw_table_data = ko.observableArray([]);

		//Chart display
		this.chart_display_count = ko.observable(0);
		this.report_id = ko.observable();
		this.data_source = ko.observable();

		this.source_schema.subscribe((schema) => {
			let tables = this.tables.filter(item => item.schema == schema).map(item => item.name);
			this.available_tables([...new Set(tables.map(item => item))]);
		});

		this.source_table.subscribe(async () => {
			await this.get_columns();
		});

		this.data_source_report.subscribe(async () => {
			this.get_report_info();
			await this.get_columns();
		});
		//Series Label
		this.available_label_options = ko.observableArray(['X-axis', 'Y-axis','Show','Rotate 90', 'Inside', 'Right', 'Formatter Currency']);
		//UI-Filters
		this.ui_fields = ko.observableArray([]);
		this.available_field_types = ko.observableArray(['text', 'list', 'date', 'number', 'boolean', 'json', 'time', 'lookup']);

		// Defaults
		this.default_currency_formatter = ' return "R " + value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })';
		this.default_label_currency_formatter = ' return "R " + value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })';
		this.default_split_formater = ' return value.replace(/^(.*)\s(.*)$/, "$1\n$2")';
		this.default_axis_label = {color: 'text_color'};
		this.default_axis_label_rotate = {rotate: 60};
	}
	
	async load ()	
	{
		this.get_exposed_assets();
		this.get_reports();
		if(this.chart_name() != '')
		{
			await this.get_chart_data();
			this.chart_display_count(1);
		}
		else{
			this.data_source_type('table');
		}
	}

	async get_chart_data ()
	{
		let data = await Grape.fetches.getJSON('/api/record', {
			schema: 'echarts',
			table: 'v_chart_info',
			filter: [
				{field: 'name', operator: '=', value: this.chart_name()}
			]
		});
		if (data.status != 'OK' || data.records.length == 0)
			return Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'Unable to find chart data.'});

		let record = data.records[0];

		this.chart_id(record.chart_id);
		this.chart_name(record.name);
		this.title(record.title[0]);
		this.legend_id(record.legend_id);
		this.tooltip_id(record.tooltip_id);

		// Data source
		this.data_source_type(record.data_source[0].data_source_options?.data_source_type);
		this.data_source_id(record.data_source[0].data_source_id);
		this.ui_fields([]);
		let ui_field_labels = [];
		for (let ds of record.data_source){
			if (ds.data_source_options?.ui_fields){
				for (let field of ds.data_source_options.ui_fields){
					if (ui_field_labels.indexOf(field.label) == -1){
						//this.ui_fields.push(field);
						this.add_ui_field(field);
						ui_field_labels.push(field.label);
					}
				}
			}
		}
		if (this.data_source_type() == 'report'){
			this.version(record.data_source[0].data_source_options.report.version);
			this.report_definition_id(record.data_source[0].data_source_options.report.definition_id);
			let dsr = this.available_reports().filter(item => item.report_definition_id == this.report_definition_id());
			this.data_source_report(dsr[0]);
			this.data_source({
				schema: 'reports_data',
				table: dsr[0].result_table
			});
		}else{
			this.data_source_type('table');
			this.source_schema(record.data_source[0].data_source_options.source_schema);
			this.source_table(record.data_source[0].data_source_options.source_table);
			this.data_source({
				schema: this.source_schema(),
				table: this.source_table()
			});
		}
		// Series
		let series = [];
		let axis_ids = [];
		for (let s of record.series){
			let series_obj = {
				series_id: ko.observable(s.series_id),
				series_name: ko.observable(s.series_name),
				series_type: ko.observable(s.series_type),
				color_by: ko.observable(s.color_by),
				coordinate_system: ko.observable(s.coordinate_system),
				series_type_options: ko.observable(s.series_type_options),
				data_source_options: ko.observable(s.data_source_options),
				x_axis_id: ko.observable(s.x_axis_id),
				y_axis_id: ko.observable(s.y_axis_id),
				symbol: ko.observable(s.symbol),
				symbol_options: ko.observable(s.symbol_options),
				data_source_id: ko.observable(s.data_source_id),
				idx: ko.observable(s.idx),
				color: ko.observable(s.color),
				x_axis_name: ko.observable(''),
				y_axis_name: ko.observable(''),
				series_column: ko.observable(''),
				series_value: ko.observable(''),
				selected_axis_options: ko.observableArray([]),
				selected_label_options: ko.observableArray([]),
				add_to_ui_fields: ko.observable(false),
				ui_label: ko.observable('')
			}
			//Series UI Field
			if (s.data_source_options.ui_field){
				series_obj.add_to_ui_fields = s.data_source_options.ui_field.add_to_ui_fields;
				series_obj.ui_label = s.data_source_options.ui_field.ui_label;
			}
			//Series Label
			if (s.series_type_options?.label?.selected_label_options)
				series_obj.selected_label_options(s.series_type_options.label.selected_label_options);
			else
				series_obj.selected_label_options([]);

			// Pie charts
			if (s.series_type == 'pie' && s.data_source_options?.source_field){
				series_obj.series_column(s.data_source_options.source_field[0]);
				series_obj.series_value(s.data_source_options.source_field[1]);
			}

			//Filter
			if (s.data_source_options?.filter){
				let filter = s.data_source_options.filter[0];
				series_obj.series_column(filter.field);
				series_obj.series_value(filter.value);
			}
			series.push(series_obj);
			if (s.x_axis_id != null && s.x_axis_id != ''){
				axis_ids.push(s.x_axis_id);
				axis_ids.push(s.y_axis_id);
			}
		}
		//Axes
		if (axis_ids.length > 0){
			let unique_axes_ids = [...new Set(axis_ids.map((item) => {return item}))]; 
			let filter = [];
			for (let axis of unique_axes_ids)
				filter.push({field: 'axis_id', operator: '=', value: axis})

			let req_obj = {
				schema: 'echarts',
				table: 'v_axis',
				filter_join: 'OR',
				filter: filter
			};
			let response = await Grape.fetches.getJSON('/api/record', req_obj);
			if (response.status != 'OK' || response.records.length == 0)
				Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No data. Please ensure you have created a report to process.'});

			this.axes.removeAll();
			this.def_grid(false);
			for (let axis of response.records){
				this.build_axis(axis);
			}
			this.def_grid(true);
		}
		// Link series to axes
		let axis_index;
		if (this.axes().length > 0){
			axis_ids = this.axes().map((item) => {return item.axis_id()});
			for (let s of series){
				axis_index = axis_ids.indexOf(s.x_axis_id());
				s.x_axis_name(this.axes()[axis_index].name());
				axis_index = axis_ids.indexOf(s.y_axis_id());
				s.y_axis_name(this.axes()[axis_index].name());
			}
		}
		this.series(series);
	}

	async get_latest_report_info (){
		req_obj = {
			schema: 'grape',
			table: 'v_pg_columns',
			filter: [
				{field: 'schema_name', operator: '=', value: 'reports_data'},
				{field: 'table_name', operator: '=', value: data.records[0].result_table}
			]
		}
		let response = await Grape.fetches.getJSON('/api/record', req_obj);
		if (response.status != 'OK' || response.records.length == 0)
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No data. Please ensure you have created a report to process.'});

		this.available_columns(response.records.map(item => item.column_name));
	}

	build_axis (axis){
		let axis_obj = {
			axis_id: ko.observable(axis.axis_id),
			name_gap: ko.observable(axis.name_gap),
			idx: ko.observable(axis.idx),
			show: ko.observable(axis.show),
			type: ko.observable(axis.type),
			name: ko.observable(axis.name),
			name_location: ko.observable(axis.name_location),
			position: ko.observable(axis.position),
			field: ko.observable(axis.field),
			layout_info: ko.observable(axis.layout_info || {}),
			selected_axis_options: ko.observableArray(axis.layout_info?.options || []) 
		};
		this.axes.push(axis_obj);

		if (axis.position == 'top' || axis.position == 'bottom')
			this.available_x_axes().push(axis.name);
		if (axis.position == 'left' || axis.position == 'right')
			this.available_y_axes().push(axis.name);

		this.def_grid(false);
		this.def_grid(true);
	}

	async btnSave_click () {
		let req_obj;
		// Data Source
		let source_obj = {
			data_source_id: this.data_source_id(),
			schema: this.data_source_type() === 'table' ? this.source_schema() : '',
			table: this.data_source_type() === 'table' ? this.source_table() : '',
			type: this.data_source_type(),
			definition_id: this.data_source_type() === 'table' ? '' : this.data_source_report().report_definition_id,
			version: this.data_source_type() === 'table' ? '' : this.data_source_report().version
		};
		if (this.ui_fields().length > 0)
			source_obj.ui_fields = ko.toJS(this.ui_fields());

		let data_source = await Grape.fetches.postJSON('/api/echarts/data/source', source_obj);
		if (data_source.status != 'OK'){
			Grape.toasts.message({ type: 'error', message: data_source.message});
			return;
		}

		this.data_source_id(data_source.data_source_id);
		
		// Axes
		if (this.axes()?.length > 0){
			for (let axis of this.axes()){
				let axis_obj = ko.toJS(axis);
				
				let layout_info = {options: []};
				for (let option of axis_obj.selected_axis_options){
					layout_info.options.push(option);
					if (option == 'Currency')
						layout_info.label_formatter = this.default_currency_formatter;
					if (option == 'Rotate Label')
						layout_info.label_rotate = this.default_axis_label_rotate;
					if (option == 'Split Label')
						layout_info.label_formatter = this.default_split_formater;
					if (option == 'Name Location - start'){
						layout_info.nameLocation = 'start';
						axis_obj.name_location = 'start';
						axis_obj.name_gap = 15;
					}
					if (option == 'Name Location - end'){
						layout_info.nameLocation = 'end';
						axis_obj.name_location = 'end';
						axis_obj.name_gap = 15;
					}
					if (option == 'Name Location - center'){
						layout_info.nameLocation = 'center';
						axis_obj.name_location = 'center';
						axis_obj.name_gap = 50;
					}
				}
				axis_obj.layout_info = layout_info;
				let response = await Grape.fetches.postJSON('/api/echarts/chart/axis', axis_obj);
				if (response.status != "OK"){
					Grape.toasts.message({ type: 'error', message: response.message});
					return;
				}
				axis.axis_id(response.axis_id);
			}
		}
		//Chart
		let chart = {
			chart_id: this.chart_id(),
			name: this.chart_name(),
			title: {
				title_id: this.title().title_id,
				text: this.title().text,
				subtext: this.title().subtext,
				layout_info: this.title().layout_info
			},
			legend: {
				legend_id: this.legend_id(),
				type: 'scroll',
				text_style : { color: 'var(--fg-c1)'}
			},
			tooltip: { trigger: 'axis'}
		};

		let series_data = this.series_builder();
		chart = {...chart, ...series_data};
		let chart_data = await Grape.fetches.postJSON('/api/echarts/chart/save', {chart});
		if (chart_data.chart_id > 0)
		{
			Grape.alerts.alert({type: 'success', title: 'Success', message: 'Chart Successfully saved'});
			this.load();
		}
		this.chart_display_count(this.chart_display_count() + 1);
	}
	
	series_builder ()
	{
	 	let series_data = ko.toJS(this.series());
		let result = {series: []};
		let default_line_options = {symbol: 'line', line_style: {type: 'solid', width: 3}}; 
			
		let axes_names = [];
		if (this.axes()?.length > 0){
			axes_names = this.axes().map((item) => {return item.name()});
		}

		for (let series of series_data) {
			let series_object = {
				series_id: series.series_id,
				name: series.series_name,
				type: series.series_type,
				coordinate_system: '',
				data_source_options: '',
				symbol: series.symbol,
				color_by: series.color_by,
				data_source_id: this.data_source_id(),
				idx: 1
			}
			//Series type options
			let series_type_options = {};
			if (series_object.type == 'pie'){
				series_type_options.radius = '65%';
				series_type_options.selectedMode = 'single';

				series_object.symbol = '';
				series_object.symbol_options = '';
			}else{
				series_object.color = series.color;
				if (series.series_type == 'line'){
					series_object.series_type_options = default_line_options;
				} else if (series.series_type == 'bar'){
					series_type_options.barMaxWidth = 40;
				}
				series_object.symbol = '';
				series_object.symbol_options = '';
			}
			// Add series label to Series Type options
			// Label
			let formatter = '';
			let value_axis = 1;
			let label = {
				'selected_label_options': series.selected_label_options,
				show: false};
			for (let label_option of series.selected_label_options){
				if (label_option == 'Show')
					label.show = true;
				if (label_option == 'Inside')
					label.position = 'inside';
				if (label_option == 'Right')
					label.position = 'right';
				if (label_option == 'Rotate 90')
					label.rotate = 90;
				if (label_option == 'Formatter Currency'){
					formatter = ' return "R " + value.data[place-holder].toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })';
				}
				if (label_option == 'X-axis')
					value_axis = 0;
			}
			if (formatter == ''){
				if (series_object.type == 'pie')
					formatter = ` return (value.data[0] + "--" + value.data[1])`;
				else
					formatter = ` return value.data[${value_axis}]`;
			}else{
				formatter = formatter.replace('place-holder', value_axis);
			}
			label.formatter = formatter;
			series_type_options.label = label;
			series_object.series_type_options = series_type_options;
			// Axes
			if (this.axes().length > 0){
				if (series.x_axis_name != ''){
					let x_axis_index = axes_names.indexOf(series.x_axis_name);
					let y_axis_index = axes_names.indexOf(series.y_axis_name);

					series_object.x_axis_id = this.axes()[x_axis_index].axis_id();
					series_object.y_axis_id = this.axes()[y_axis_index].axis_id();
					// Data Source Options
						//Filter
					let filter;
					let ui_field = {};
					if (series.series_column != '' && series.series_value != ''){
						filter = [{"field": series.series_column, "operant": "=", "value": series.series_value}];

						ui_field = {add_to_ui_fields: series.add_to_ui_fields,
								ui_label: series.ui_label
						};
					}

					let source_field = [this.axes()[x_axis_index].field(), this.axes()[y_axis_index].field()];
					if (this.axes()[y_axis_index].type() == 'category')
						source_field = [this.axes()[y_axis_index].field(), this.axes()[x_axis_index].field()];
					
					series_object.data_source_options = {source_field: source_field, filter: filter, ui_field: ui_field};
				}
				if (series_object.x_axis_id != '' && series_object.y_axis_id != '')
					series_object.coordinate_system = 'cartesian2d';
			}else{
				let source_field = [series.series_column, series.series_value];
					series_object.data_source_options = {source_field: source_field};
			}
		//	let data_source_id = await this.data_source_builder();
		//	series_object.data_source_id = data_source_id;

			result.series.push(series_object);
		};
		return result;
	}

	async data_source_builder (series_name, data_source_options){
		// Data Source
		let source_obj = {
			data_source_id: this.data_source_id(),
			schema: this.data_source_type() === 'table' ? this.source_schema() : '',
			table: this.data_source_type() === 'table' ? this.source_table() : '',
			type: this.data_source_type(),
			definition_id: this.data_source_type() === 'table' ? '' : this.data_source_report().report_definition_id,
			version: this.data_source_type() === 'table' ? '' : this.data_source_report().version,
			data_source_options: data_source_options
		};
		let new_ui_fields = [];
		if (this.ui_fields().length > 0){
			let ui_fields = ko.toJS(this.ui_fields());
			for (let field of ui_fields){
				if (field.type == 'series'){
					if (field.name == series_name)
						new_ui_fields.push(field);
				}else{
					new_ui_fields.push(field);
				}
			}
		}
		if (this.new_ui_fields().length > 0)
			source_obj.ui_fields = new_ui_fields;

		let data_source = await Grape.fetches.postJSON('/api/echarts/data/source', source_obj);
		if (data_source.status != 'OK'){
			Grape.toasts.message({ type: 'error', message: data_source.message});
			return null;
		}
		return data_source.data_source_id;
	}

	async get_exposed_assets()
	{
		let response = await Grape.fetches.getJSON('/api/echarts/chart/exposed_assets', {});
		if (response.status !== 'OK') {
			Grape.toasts.message({ type: 'error', message: response.message});
			return;
		}

		this.assets = response.records;
		let schemas = [...new Set(this.assets.map(item => item.schema))];
		this.tables = this.assets.filter(item => item.type == 'table');
		this.available_schemas(schemas);
	}

	get_exposed_table_views(){
		let table_views = this.tables.filter((item) => item.schema == this.source_schema());
		this.available_tables([...new Set(table_views.map(item => item.name))]);
	}

	async get_reports(){
		let response = await Grape.fetches.getJSON('/api/record', {schema: 'reports', table: 'v_latest_reports'});
		if (response.status != 'OK'){
			Grape.toasts.message({ type: 'error', message: response.message});
			return;
		}
		let reports_definitions = response.records.map(rec => {
			return {
				report_definition_id: rec.report_definition_id,
				definition_name: rec.name,
				version: rec.version,
				result_table: rec.result_table,
				params: rec.default_function_criteria,
				report_id:rec.report_id
			}
		});
		this.available_reports(reports_definitions);
	}

	async get_columns ()
	{
		let filter;
		if (this.data_source_type() == 'report'){
			filter = [
				{field: 'schema_name', operator: '=', value: 'reports_data'},
				{field: 'table_name', operator: '=', value: this.data_source_report().result_table}
			];
		}else{
			filter = [
				{field: 'schema_name', operator: '=', value: this.source_schema()},
				{field: 'table_name', operator: '=', value: this.source_table()}
			];
		}

		let response = await Grape.fetches.getJSON('/api/record', {
			schema: 'grape',
			table: 'v_pg_columns',
			limit: 5000,
			filter: filter,
			fields: ['column_name']
		});
		this.available_columns(response.records.map(item => item.column_name));
	}

	async get_report_info ()
	{
		for (let report of this.available_reports()){
			if (report.definition_name == this.data_source_report().definition_name){
				this.version(report.version);
				this.report_definition_id(report.report_definition_id);
				this.report_id(report.report_id);
				this.report_table(report.result_table);
			}
		}
	}

	btn_add_axis_click (){
		this.build_axis ({
			axis_id: '',
			name_gap: 50,
			idx: 1,
			show: true,
			type: '',
			name: '',
			name_location: 'middle',
			position: '',
			field: '',
			selected_axis_options: []
		});
	}
	btn_remove_axis(index){
		if (this.axes().length > 0)
			this.axes.splice(index, 1);
		if (this.axes().length == 0)
			this.def_grid(false);
	}

	btnAdd_series_click ()
	{
		for (let axis of this.axes()){
			if (axis.position() == 'top' || axis.position() == 'bottom'){
				if (this.available_x_axes().indexOf(axis.name() == -1))
					this.available_x_axes().push(axis.name());
			}
			else{
				if (this.available_y_axes().indexOf(axis.name() == -1))
					this.available_y_axes().push(axis.name());
				
			}
		};
		this.series.push({ 
			series_id: ko.observable(''),
			series_name: ko.observable(''),
			series_type: ko.observable(''),
			color_by: ko.observable(''),
			coordinate_system: ko.observable(''),
			series_type_options: ko.observable(''),
			data_source_options: ko.observable(''),
			x_axis_id: ko.observable(''),
			y_axis_id: ko.observable(),
			symbol: ko.observable(''),
			symbol_options: ko.observable(''),
			data_source_id: ko.observable(''),
			idx: ko.observable(1),
			color: ko.observable(''),
			x_axis_name: ko.observable(''),
			y_axis_name: ko.observable(''),
			series_column: ko.observable(''),
			series_value: ko.observable(''),
			add_to_ui_fields: ko.observable(false),
			ui_label: ko.observable(''),
			selected_label_options: ko.observableArray([])
		});
	}

	btnRemove_series_click (index)
	{
		if (this.series().length > 0)
			this.series.splice(index, 1);
	}

	btn_remove_ui_filter_row_click(index){
		if (this.ui_fields().length > 0)
			this.ui_fields.splice(index, 1);
	}

	add_ui_field(field){
		let field_obj = {
			label: ko.observable(field?.label || ''), 
			name: ko.observable(field?.name || ''), 
			type: ko.observable(field?.type || ''),
			list_options: ko.observable(field?.list_options || ''),
			operator: ko.observable(field?.operator || ''),
			default_value: ko.observable(field?.default_value || ''),
			lookup: ko.observable(field?.lookup || ''),
			list_value_field: ko.observable(field?.list_value_field || '')
		};
		this.ui_fields.push(field_obj);
	}

	btn_add_ui_field_row_click ()
	{
		this.add_ui_field();
	}

	btn_remove_ui_field_row_click(index){
		if (this.ui_fields().length > 0)
			this.ui_fields.splice(index, 1);
	}

	reload_report_cb = (obj) => {this.reload_report_definition(obj),this};

	reload_report_definition (obj){
		this.report_definition_id(obj.report_definition_id);
		this.version(obj.version);
		this.report_id(obj.report_id);
		let ds_obj = this.data_source_report();
		if (ds_obj == ''){
			ds_obj = {
				report_definition_id: this.report_definition_id(),
				version: this.version(),
				definition_name: '',
				result_table: obj.result_table,
				params: '',
				report_id: this.report_id()
			};
		}else{
			ds_obj.version = this.version();
			ds_obj.report_id = this.report_id();
			ds_obj.result_table = obj.result_table;
		}
		this.data_source_report(ds_obj);
		this.data_source({
			schema: 'reports_data',
			table: obj.result_table
		});
		this.chart_display_count(this.chart_display_count() + 1);
	}
}

/**
 * page class
 */
class ChartViewPageClass
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ChartViewPageViewModel(this);
		this.name = 'ChartViewPageClass';
	}

	async init ()
	{
		this.viewModel.chart_name(this.bindings?.chart_name);
		await this.viewModel.load();
	}

	async teardown ()
	{
	}
}

export default {
	route: '[/]charts/chart-view/:chart_name',
	page_class: ChartViewPageClass,
	template: template
}
